import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {map} from 'rxjs';
import {AuthValidationService} from '../../projects/auth/src/lib/services/auth-validation.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authValidationService = inject(AuthValidationService);
  const router = inject(Router);

  // validateToken() handles all cases:
  // - valid access token → passes through
  // - expired access token → silently refreshes via HttpOnly cookie, then validates
  // - no access token (e.g. new tab) → silently refreshes via HttpOnly cookie
  // - no tokens at all → returns isValid: false → redirect to login
  return authValidationService.validateToken().pipe(
    map(result => {
      //console.log('* authGuard: server validation result:', result.isValid);
      if (result.isValid) {
        return true;
      }
      return router.createUrlTree(['/login'], {queryParams: {returnUrl: state.url}});
    })
  );
};

